import dao from './ducks/dao';

export const { getItemPropById } = dao.selectors;
